/**
 * Optimized base64 decode using atob on the browser rather than shipping node_modules/buffer to the browser
 */
export const base64decode =
    typeof window === "undefined"
        ? // nodejs
          (str: string) => Buffer.from(str, "base64").toString("utf8")
        : // browser
          (str: string) => atob(str);
